import { useUI } from '@context/GlobalUIContext';
import { useTranslation } from 'next-i18next';
import styles from './SelectStoreMessage.module.scss';

const SelectStoreMessage = () => {
  const { t } = useTranslation('pdp');
  const { openStockLevelModal } = useUI();

  return (
    <p>
      {t('product.free.store.pickup.select.store.select')}{' '}
      <button
        className={styles.storeNameButton}
        onClick={() => openStockLevelModal()}
      >
        {t('product.free.store.pickup.select.store.button')}
      </button>{' '}
      {t('product.free.store.pickup.select.store.to.view.pickup.availability')}
    </p>
  );
};

export default SelectStoreMessage;
